module.exports = __webpack_public_path__ + "img/imgisam.9f9ffa6a.png";